// extracted by mini-css-extract-plugin
module.exports = {"label":"_32bbee5fda--label--EIVCh","container":"_32bbee5fda--container--eu5DF","tooltip-container":"_32bbee5fda--tooltip-container--abAAl"};